import type { FC } from "react";

import { Blocks, isEditing } from "@builder.io/sdk-react";

import { PopupVideo as UiPopupVideo } from "@jti/ui/components/PopupVideo";

import type { popupVideoInputs } from "./PopupVideo.builder";

type PopupVideoBuilderProps = Override<
  BuilderComponentProps<typeof popupVideoInputs>,
  {
    videoPlayer?: BuilderBlock[];
  }
>;

export const PopupVideo: FC<PopupVideoBuilderProps> = ({
  theme,
  color,
  videoPlayer,
  label,
  builderBlock,
  alignment,
}) => {
  return (
    <UiPopupVideo
      isInEditor={isEditing()}
      videoPlayer={<Blocks blocks={videoPlayer} path="videoPlayer" parent={builderBlock?.id} />}
      color={color}
      theme={theme}
      label={label}
      alignment={alignment}
    />
  );
};
